'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Left;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function Left(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      className: 'icon-svg-chevron-left ' + className,
      width: width,
      height: height,
      viewBox: '0 0 28 28' },
    _react2.default.createElement('path', { fill: '#404344', fillRule: 'evenodd', d: 'M20.1424139,6.0918399 L12.2342538,14 L20.1424139,21.9081601 C20.5147378,22.280484 20.5147378,22.8762023 20.1424139,23.2485262 L17.6701831,25.7207571 C17.2978591,26.093081 16.7021409,26.093081 16.3298169,25.7207571 L5.27924294,14.6701831 C4.90691902,14.2978591 4.90691902,13.7021409 5.27924294,13.3298169 L16.3298169,2.27924294 C16.7021409,1.90691902 17.2978591,1.90691902 17.6701831,2.27924294 L20.1424139,4.75147378 C20.5147378,5.1237977 20.5147378,5.71951598 20.1424139,6.0918399 Z' })
  );
}

Left.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Chevron/Left.js
// module id = 153
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14